import { render, staticRenderFns } from "./Wysiwyg.vue?vue&type=template&id=b71bee90&scoped=true&"
import script from "./Wysiwyg.vue?vue&type=script&lang=js&"
export * from "./Wysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./Wysiwyg.vue?vue&type=style&index=0&id=b71bee90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71bee90",
  null
  
)

export default component.exports